import type { GuideTourStep } from "../../GuideTour/types";

/** Selectors match ids on `WhitelabelPaymentHelpShell`. */
export const WL_PAYMENT_HELP_CRYPTO_STEPS: GuideTourStep[] = [
  {
    id: "pay-overview",
    selector: "#wl-pay-overview",
    content:
      "You can reach this crypto payment screen after creating a brand or when topping up your wallet — the steps are the same.",
  },
  {
    id: "pay-plan",
    selector: "#wl-pay-plan-summary",
    content: "Confirm plan, amount, and points before sending crypto — whether you came from checkout or top-up.",
  },
  {
    id: "pay-crypto-currency",
    selector: "#wl-pay-crypto-currency",
    content:
      "Open the network list, then pick a USDT chain (for example USDT ETHEREUM). The USDT estimate in the plan summary, plus your deposit address and QR, only appear after you choose USDT.",
  },
  {
    id: "pay-crypto-deposit",
    selector: "#wl-pay-crypto-deposit",
    content:
      "Copy the wallet address or scan the QR from your wallet app — send the exact amount shown on your plan.",
  },
  {
    id: "pay-crypto-done",
    selector: "#wl-pay-crypto-done",
    content: "After the blockchain confirms, your payment status updates automatically.",
  },
];

export const WL_PAYMENT_HELP_FIAT_STEPS: GuideTourStep[] = [
  {
    id: "pay-overview",
    selector: "#wl-pay-overview",
    content:
      "UPI and bank transfer work the same after brand checkout or from a wallet top-up — you’ll use this fiat screen in both cases.",
  },
  {
    id: "pay-plan",
    selector: "#wl-pay-plan-summary",
    content: "Check the amount and points before you pay, from either brand billing or top-up.",
  },
  {
    id: "pay-fiat-tabs",
    selector: "#wl-pay-fiat-tabs",
    content: "Switch between UPI and bank transfer depending on how you pay.",
  },
  {
    id: "pay-fiat-upi",
    selector: "#wl-pay-fiat-upi",
    content: "Use the UPI QR or intent link, complete payment in your banking app, then return here.",
  },
  {
    id: "pay-fiat-bank",
    selector: "#wl-pay-fiat-bank",
    content: "For bank transfer, copy account details, pay from your bank, then keep the reference handy.",
  },
  {
    id: "pay-fiat-proof",
    selector: "#wl-pay-fiat-proof",
    content:
      "Upload a clear payment screenshot (required). Use Upload, pick your proof image, then continue to Submit.",
  },
  {
    id: "pay-fiat-submit",
    selector: "#wl-pay-fiat-submit",
    content: "After your screenshot is attached, tap Submit so we can verify your UPI or bank transfer.",
  },
];

export const WL_PAYMENT_HELP_OFFLINE_STEPS: GuideTourStep[] = [
  {
    id: "pay-overview",
    selector: "#wl-pay-overview",
    content: "Offline payment is for teams who settle outside the instant card/UPI/crypto rails.",
  },
  {
    id: "pay-plan",
    selector: "#wl-pay-plan-summary",
    content: "You still pick your plan first; payment is completed manually with our team.",
  },
  {
    id: "pay-offline-info",
    selector: "#wl-pay-offline-info",
    content:
      "Same as checkout: read the notice — you are only raising a request; our team contacts you to finish payment offline.",
  },
  {
    id: "pay-offline-submit",
    selector: "#wl-pay-offline-submit",
    content: "Tap Submit request — nothing is charged in the app; our team reaches out next.",
  },
];

export const WL_PAYMENT_HELP_STEPS_BY_METHOD = {
  crypto: WL_PAYMENT_HELP_CRYPTO_STEPS,
  fiat: WL_PAYMENT_HELP_FIAT_STEPS,
  offline: WL_PAYMENT_HELP_OFFLINE_STEPS,
} as const;

export type WhitelabelPaymentHelpMethod = keyof typeof WL_PAYMENT_HELP_STEPS_BY_METHOD;
